import React from 'react';
import PropTypes from 'prop-types';

import { Text, WithTooltip, Icon } from 'components/common/Elements/Elements';

import { cutTextforToltip } from 'utils/common';

import classes from './CutIfToltip.module.scss';

const CutIfToltip = ({ data, length, text, type }) => {
  if (data.length > length && data !== '-' && data !== 'NA') {
    const textTooltip = () => (
      <div className={classes.tooltip}>
        <a
          href={type === 'mail' ? `mailto:${data}` : data}
          target="_blank"
          rel="noreferrer noopener"
        >
          <Text type="p" className={classes.tooltip_text} size={2}>
            {data}
            {type === 'mail' && (
              <Icon icon="mail" size="12px" className={classes.tooltip_email} />
            )}
          </Text>
        </a>
      </div>
    );

    return (
      <WithTooltip text={textTooltip()}>
        <div>
          {!text ? (
            <Text className={classes.value}>
              {cutTextforToltip(data, length - 3)}
            </Text>
          ) : (
            <a
              className={classes.link}
              href={type === 'mail' ? `mailto:${data}` : data}
              target="_blank"
              rel="noreferrer noopener"
            >
              {text}
            </a>
          )}
        </div>
      </WithTooltip>
    );
  }
  return data;
};

CutIfToltip.propTypes = {
  data: PropTypes.string,
  length: PropTypes.number,
  type: PropTypes.string,
  text: PropTypes.string
};

export default CutIfToltip;
